import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "parameter" }
const _hoisted_2 = { class: "parameter__name" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "parameter__record-title" }
const _hoisted_5 = { class: "parameter__name" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "parameter__separator"
}
const _hoisted_8 = { class: "parameter__record-title" }


import { Parameter } from "@/store/search";


export default /*@__PURE__*/_defineComponent({
  ...{ name: "ProjectListItemParameter" },
  __name: 'ProjectListItemParameter',
  props: {
    parameter: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_ProjectListItemParameter = _resolveComponent("ProjectListItemParameter", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.parameter.Type === 0 && _ctx.parameter.Instance)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.parameter.Instance.IsRecord)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.parameter.Instance.Key) + ": ", 1),
                _createElementVNode("span", {
                  class: "parameter__value",
                  innerHTML: _ctx.parameter.Instance.Value
                }, null, 8, _hoisted_3)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('record_label')) + " \"" + _toDisplayString(_ctx.parameter.Instance.Key) + "\":", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameter.Instance.RecordFields, (field, idx) => {
                  return (_openBlock(), _createBlock(_component_ProjectListItemParameter, {
                    key: idx,
                    parameter: field,
                    class: "parameter__nested"
                  }, null, 8, ["parameter"]))
                }), 128))
              ], 64))
        ], 64))
      : (_ctx.parameter.Type === 1 && _ctx.parameter.ListTitle)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.parameter.ListTitle.Name) + ": ", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameter.ListTitle.Instances, (inst, idx) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                (!inst.IsRecord)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", {
                        class: "parameter__value",
                        innerHTML: inst.Value
                      }, null, 8, _hoisted_6),
                      (idx < _ctx.parameter.ListTitle.Instances.length - 1 && inst.Value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "; "))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('record_label')) + " \"" + _toDisplayString(inst.Key) + "\":", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inst.RecordFields, (field, fIdx) => {
                        return (_openBlock(), _createBlock(_component_ProjectListItemParameter, {
                          key: fIdx,
                          parameter: field,
                          class: "parameter__nested"
                        }, null, 8, ["parameter"]))
                      }), 128))
                    ], 64))
              ], 64))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
  ]))
}
}

})